<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Renovações'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters complete-filter">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="info-card-blue">
                    <div>1</div>
                    <div>Data início e fim</div>
                    <div>Preencha os filtros para buscar um Excel mais detalhado.</div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker ref="programaticOpen3" v-model="filters.initialDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker ref="programaticOpen4" v-model="filters.finalDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../../components/default/topMenu.vue";
import pageHeader from "../../../components/default/pageHeader.vue";
import fullLoading from "../../../components/default/fullLoading.vue";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import swal from 'sweetalert';

import {
  GET_LIST_RENEW
} from "../../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../../requestConfig";
import {
  UTIL
} from "../../../../../utils";
import {
  ALERT_SERVICE
} from "../../../../../msgAlertService";

export default {
  name: "list-renews",
  components: {
    topMenu,
    datepicker,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      ptBR: ptBR,
      filters: {
        initialDate: '',
        finalDate: ''
      },
      failRequest: false,
      loadingList: false,
      pageNumber: 1,
      qtdTotal: 0,
      pageQtd: 20,
      totalPages: 0,
      dataResult: {}
    }
  },
  methods: {
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getList() {
      if (this.filters.initialDate && this.filters.finalDate) {
        this.dataResult = [];

        this.loadingList = true;
        this.failRequest = false;

        let url = GET_LIST_RENEW;
        url += "?init=" + moment(this.filters.initialDate).format("YYYY-MM-DD");
        url += "&end=" + moment(this.filters.finalDate).format("YYYY-MM-DD");

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_LIST_RENEW:", response.data);

          this.downloadActualListExcel(response.data);

          this.loadingList = false;
        }).catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      } else {
        swal('Aviso', 'Preencha as datas para continuar.', 'warning');
      }
    },
    downloadActualListExcel(response) {
      let bodyValue = [];
      response.map((value, index) => {
        bodyValue.push([
          value.name,
          value.newCompanyPlanStr,
          value.pplanTypeStr,
          value.newPlanTypeStr,
          value.firstPaymentPrice,
          value.totalCost,
          value.pricePerEmployee,
          value.maxTotalEmployeeInContract,
          value.newFirstPaymentPrice,
          value.newTotalCost,
          value.newPricePerEmployee,
          value.newMaxTotalEmployeeInContract,
          value.newTotalEmployeeFirstPayment,
          value.notes,
          value.generateInvoice,
          value.defaultQuantity,
          moment(String(value.initDate)).format('DD/MM/YYYY hh:mm'),
          moment(String(value.newInitDate)).format('DD/MM/YYYY hh:mm'),
          moment(String(value.contractValidUntil)).format('DD/MM/YYYY hh:mm'),
          moment(String(value.newContractValidUntil)).format('DD/MM/YYYY hh:mm'),
          moment(String(value.createdAt)).format('DD/MM/YYYY hh:mm')
        ]);

        if (index + 1 === response.length) {
          let headValue = [
            "EMPRESA",
            "PLANO",
            "TIPO",
            "NOVO TIPO",
            "PRIMEIRO PAGAMENTO",
            "CUSTO TOTAL",
            "PREÇO POR FUNCIONÁRIO",
            "PREÇO MÁXIMO POR FUNCIONÁRIO EM CONTRATO",
            "NOVO PRIMEIRO PAGAMENTO",
            "NOVO CUSTO TOTAL",
            "NOVO PREÇO POR FUNCIONÁRIO",
            "NOVO PREÇO MÁXIMO POR FUNCIONÁRIO EM CONTRATO",
            "NOVO PREÇO POR FUNCIONÁRIO PRIMEIRO PAGAMENTO",
            "OBSERVAÇÃO",
            "NOTA GERADA",
            "defaultQuantity",
            "DATA INICIAL",
            "NOVA DATA INICIAL",
            "DATA DO CONTRATO",
            "NOVA DATA DO CONTRATO",
          ];
          window.downloadListExcel(headValue, bodyValue, "Lista de Renovações");
        }
      });
    },
  }
}
</script>

<style lang="scss">
.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}

.complete-filter {
  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

  button {
    width: auto;
    margin-top: 20px;
    padding: 0 20px;
  }
}

.price-value {
  display: block;
  margin-bottom: 20px;
  font-weight: 600;
  text-transform: capitalize;
  color: #444d58;
  font-size: 16px;
  margin-left: 6px;
  margin-top: 0;

  span {
    color: #e7505a;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/payment/list-renews/listRenews.vue